<template>
    <div class=""> <!-- w-25 container-->
        <div>
            <div class="d-flex justify-content-center align-items-center">
                <h2 :class="`letras-${n}`" class="my-0" style="user-select: none;">{{verCaptcha}}</h2>
                
            </div>
            <div class="input-group">
                <input type="text"  v-on:keyup.enter="verificar" v-model.trim="inputCaptcha" @input="forceUpper()" class="form-control form-control-lg" placeholder="Ingrese el código" aria-label="Recipient's username" aria-describedby="button-addon2">
                <div class="input-group-append">
                    <button type="button" class="btn btn-primary" @click="createCaptcha()"><i class="fas fa-sync-alt"></i></button>
                    <!-- <button @click="verificar()" class="btn btn-primary padding-search" type="button" id="button-addon2">Verificar</button> -->
                </div>
            </div> 
        </div>  
    </div>
</template>
<script>

export default({
    name: 'capcha',
    data: function(){
        return {
            verCaptcha: '',
            inputCaptcha: '',
            verificarCaptcha: '',
            n:1
        }
    },
    methods: {
        createCaptcha(){
            let input = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'; 
            let Captcha = input[Math.floor(Math.random()*input.length)];
            for(let i=0; i<4;i++){
                Captcha = Captcha + input[Math.floor(Math.random()*input.length)];
            }
            this.random();
            this.verCaptcha = Captcha;
            //cuando hay cambio en el captcha, es necesario enviarlo al componente padre
            this.$emit('verCaptcha', this.verCaptcha);
            this.inputCaptcha = '';
        },
        verificar(){
            if(this.verCaptcha == this.inputCaptcha) return true;
            else return false;
            
        },
        forceUpper(){
            this.inputCaptcha = this.inputCaptcha.toUpperCase();
            this.$emit('inputCaptcha', this.inputCaptcha);
        },
        random(){
            let random = Math.random() * (5 - 1) + 1;
            this.n = Math.trunc(random);
            return this.n;
        }
    },
    created(){
        this.createCaptcha();
        this.$emit('verCaptcha', this.verCaptcha);
    }
})
</script>

<style scoped>
    .form-control:focus { box-shadow: none; }
    .btn.focus, .btn:focus { box-shadow: none; }
    input { text-align: center }

    .letras-1{ font-family: 'Audiowide', cursive; }
    .letras-2{ font-family: 'Palette Mosaic', cursive; }
    .letras-3{ font-family: 'Bangers', cursive; }
    .letras-4{ font-family: 'Press Start 2P', cursive; }
    .letras-5{ font-family: 'Tourney', cursive; }

</style>
